import { apiFetch } from "../utils/api";

export interface DashboardOverviewResponse {
  statusCounts: Record<string, number> & { total: number };
  totals: {
    todayOrders: number;
    yesterdayOrders: number;
    todayRevenue: number;
    yesterdayRevenue: number;
  };
  currencySymbol: string | null;
}

export const fetchDashboardOverview = () =>
  apiFetch<DashboardOverviewResponse>("/dashboard/overview");

export interface Paginated<T> {
  data: T[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export interface NextDueRow {
  id: string;
  orderId: string;
  orderNumber: string | null;
  customerName: string | null;
  productName: string | null;
  dueDate: string; // ISO
  daysLeft: number;
}

export const fetchNextDueAbandoned = (page = 1, limit = 10, bucket?: 'thisWeek' | 'nextWeek' | 'thisMonth' | 'nextMonth') =>
  apiFetch<Paginated<NextDueRow>>(`/dashboard/next-due/abandoned?page=${page}&limit=${limit}${bucket ? `&bucket=${bucket}` : ''}`);

export const fetchNextDueOrderItems = (page = 1, limit = 10, bucket?: 'thisWeek' | 'nextWeek' | 'thisMonth' | 'nextMonth') =>
  apiFetch<Paginated<NextDueRow>>(`/dashboard/next-due/order-items?page=${page}&limit=${limit}${bucket ? `&bucket=${bucket}` : ''}`);

export interface SalesPipelinesSummary {
  thisWeek: number;
  nextWeek: number;
  thisMonth: number;
  nextMonth: number;
  revenue?: {
    thisWeek: number;
    nextWeek: number;
    thisMonth: number;
    nextMonth: number;
  };
  currencySymbol?: string | null;
}

export const fetchSalesPipelinesSummary = () =>
  apiFetch<SalesPipelinesSummary>(`/dashboard/sales-pipelines/summary`);

export const fetchOverdueAbandoned = (fromISO: string, toISO: string, page = 1, limit = 500) =>
  apiFetch<Paginated<NextDueRow>>(`/dashboard/overdue/abandoned?from=${encodeURIComponent(fromISO)}&to=${encodeURIComponent(toISO)}&page=${page}&limit=${limit}`);

export const fetchOverdueOrderItems = (fromISO: string, toISO: string, page = 1, limit = 500) =>
  apiFetch<Paginated<NextDueRow>>(`/dashboard/overdue/order-items?from=${encodeURIComponent(fromISO)}&to=${encodeURIComponent(toISO)}&page=${page}&limit=${limit}`);

export interface CustomerVehicleNextDueRow {
  orderId: string;
  orderNumber: string | null;
  productVariantId: string;
  productName: string | null;
  dueDate: string;
  daysLeft: number;
}

export const fetchCustomerVehicleNextDueOrderItems = (
  customerId: string,
  customerVehicleId: string,
  limit = 5,
) =>
  apiFetch<CustomerVehicleNextDueRow[]>(
    `/dashboard/next-due/order-items/by-customer-vehicle?customerId=${encodeURIComponent(
      customerId,
    )}&customerVehicleId=${encodeURIComponent(
      customerVehicleId,
  )}&limit=${limit}`,
  );

export interface SalesPipelineAppointmentRow {
  id: string;
  appointmentId: string;
  customerName: string | null;
  scheduledAt: string;
  locationName: string | null;
  estimatedTotal: number;
}

export const fetchSalesPipelineAppointments = (
  bucket: 'thisWeek' | 'nextWeek' | 'thisMonth' | 'nextMonth',
  page = 1,
  limit = 5,
) =>
  apiFetch<Paginated<SalesPipelineAppointmentRow>>(
    `/dashboard/sales-pipelines/appointments?bucket=${bucket}&page=${page}&limit=${limit}`,
  );
